var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"full-bleed"},[_c('cld-image',{attrs:{"public-id":_vm.imageURL,"loading":"lazy","width":"100%","height":"100%"}},[_c('cld-placeholder',{attrs:{"type":"predominant-color"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }